import React from 'react';

export const Game = React.lazy(() => import('./Game'));
